module.exports = __webpack_public_path__ + "img/10979907_L.e332f893.png";